import { Link, Spinner, Stack } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainCard from '../../../components/MainCard/Index';
import { TextL, TextXS } from '../../../components/Text/Index';
import { useRequestDetailSelectiveProcess } from '../../../services/hooks/SelectiveProcess/useRequestDetailSelectiveProcess';
import { useRequestMyImpugnation } from '../../../services/hooks/CandidateArea/useRequestMyImpugnation';
import Impugnation from '../CandidateArea/Impugnation/Index';
import { useContext } from 'react';
import { ContextAuth } from '../../../contexts/Authentication';
import ResourceDetailMobilePage, { IGenericResources } from './mobile/detail';
import { IResourceItem } from './mobile/detail/cardDetail';

const ImpugnationSolicitation: React.FC = () => {
  const spId = useLocation().pathname.split('/')[3];
  const { data, isLoading } = useRequestDetailSelectiveProcess(spId);
  const impugnationList = useRequestMyImpugnation();
  const navigate = useNavigate();
  const { isMobile } = useContext(ContextAuth);

  const listResources: IResourceItem[] | undefined =
    impugnationList?.data &&
    impugnationList.data.map((item) => ({
      id: item.id,
      status: item.status,
      code: item.protocol,
      createdAt: item.created_at,
    }));

  const dataToResource: IGenericResources = {
    selectiveProcess: data?.name,
    identification: 'Contra os termos do edital',
    isOpen: data?.general_info?.open_impugnation,
    period: data?.impugnation_period,
    listItem: listResources,
  };

  if (isMobile) return <ResourceDetailMobilePage id={spId} isImpugnation {...{ isLoading, dataToResource }} />;

  const isLoadingPage = isLoading || impugnationList.isLoading;

  return (
    <MainCard height="100%" title="ÁREA DO CANDIDATO" subtitle="- IMPUGNAÇÃO CONTRA O EDITAL">
      {isLoadingPage ? (
        <Stack align="center" justify="center" h="100%" px={['10px', '10px', '10px', '50px', '50px']} gap={10}>
          <Spinner size={'xl'} />
        </Stack>
      ) : (
        <Stack px={['10px', '10px', '10px', '50px', '50px']} gap={10}>
          <Stack>
            <TextL>{data?.name}</TextL>
            {data?.impugnation_period && (
              <TextXS>
                <strong>Período para impugnação contra o edital: </strong>
                {data?.impugnation_period}
              </TextXS>
            )}
          </Stack>

          {!impugnationList?.data && (
            <Stack>
              <TextXS fontWeight="bold">Você não possui impugnações protocoladas nesse edital</TextXS>
            </Stack>
          )}

          <Impugnation />

          {data?.general_info?.open_impugnation && (
            <Stack>
              <TextL>Criar impugnação contra o edital</TextL>
              <TextXS>
                Para criar uma nova impugnação,{' '}
                <Link
                  onClick={() => {
                    navigate(`/painel/${spId}/impugnacao`);
                  }}
                  color="colorLink"
                >
                  Clique aqui
                </Link>
              </TextXS>
            </Stack>
          )}
        </Stack>
      )}
    </MainCard>
  );
};
export default ImpugnationSolicitation;
